import { PortableText } from '@portabletext/react';
import { FC } from 'react';

import { postPortableTextComponents } from '@/src/assets/PTComponents/portableTextComponents';
import { Block } from '@/src/assets/interfaces/blockInterface';

import Wrapper from '../../UI/wrapper/Wrapper';

import styles from './BlogPostContent.module.scss';

interface BlogPostContentProps {
    content: Block[];
}

const BlogPostContent: FC<BlogPostContentProps> = ({ content }) => {
    return (
        <Wrapper>
            <div className={styles.postContent}>
                <PortableText value={content} components={postPortableTextComponents} />
            </div>
        </Wrapper>
    );
};

export { BlogPostContent };
